import type { SvelteComponent } from 'types/svelte';

/**
 * Instantiate a Svelte component onto its parent container.
 */
export function replaceContainer(
  Component: SvelteComponent.Initializer,
  options: SvelteComponent.Options,
): SvelteComponent.API {
  const frag = document.createDocumentFragment();

  const component = new Component(Object.assign({}, options, { target: frag }));

  options.target.replaceWith(frag);

  return component;
}
